export default "__VITE_ASSET__BggbhIzZ__"